<script>
export default {
    name: "ErrorHandler",
    props: { errors: Array }
};
</script>

<template>
    <div class="main-content">
        <slot/>
        <ul class="indent">
            <li class="alert" v-for="(error, e) in errors" :key="e">{{ error }}</li>
        </ul>
    </div>
</template>